module.exports = __webpack_public_path__ + "static/media/background_1920-6.1e0eb550.jpg";